import Button from '@/components/atoms/Button';
import { ProductSummary } from '@/services/ecommerce/utils/helper';
import _, { toLower } from 'lodash';
import { IoMdCheckmark } from 'react-icons/io';
import styles from './product.module.scss';

const Attributes = ({ item, onVariantClick, selectedAttributes, product, selectedVariant }) => {
	const d_product: any = ProductSummary(selectedVariant);
	return (
		<div className='my-15'>
			<span className='text-18'>
				<span className='text-grey700  fw-500'>
					{item.vt_title} :{' '}
					<span className='text-capitalize fw-600 text-grey900'>{`${item?.vt_config?.length}`}</span>
				</span>

				<div className={'d-flex mt-20 ' + styles.brandAttribute}>
					{item.vt_title === 'Color' ? (
						<ColorAttribute
							selectedAttributes={selectedAttributes}
							onVariantClick={onVariantClick}
							product={product}
							item={item}
							discountPercentage={d_product?.discountPercentage}
						/>
					) : (
						<div className='d-flex flex-wrap gap-10'>
							{item?.vt_config?.map((o: any, i: any) => {
								return (
									<span key={i}>
										<Button
											extraText={d_product?.discountPercentage}
											onClick={() => onVariantClick(toLower(item.vt_title), o)}
											type={
												o === _.get(selectedAttributes, toLower(item.vt_title))
													? 'veriant-active'
													: 'veriant'
											}
											style={{
												height: 42,
												width: '100%',
												border: `${
													o === _.get(selectedAttributes, toLower(item.vt_title))
														? '1px solid #e2e8f0 !important'
														: ''
												}`,
												textTransform: 'capitalize'
											}}
											label={
												<div className='d-flex items-center gap-5'>
													{product?.p_type === 'beauty' &&
														o === _.get(selectedAttributes, toLower(item.vt_title)) && (
															<IoMdCheckmark size={24} />
														)}
													{o}
												</div>
											}
										/>
									</span>
								);
							})}
						</div>
					)}
				</div>
			</span>
		</div>
	);
};

const ColorAttribute = ({ item, onVariantClick, selectedAttributes, product, discountPercentage }) => {
	const isBeauty = product?.p_type === 'beauty';
	if (isBeauty) {
		return (
			<>
				<div className='d-flex flex-wrap gap-10'>
					{item?.vt_config?.map((o: any, i: any) => (
						<span key={i}>
							<Button
								onClick={() => onVariantClick(toLower(item.vt_title), o)}
								type={_.get(selectedAttributes, toLower(item?.vt_title)) ? 'light' : 'light'}
								style={{
									height: 42,

									backgroundColor: o,
									color: o === 'White' ? '#718096' : '#fff',
									border: `${_.get(selectedAttributes, toLower(item.vt_title)) ? '1px solid #e2e8f0 !important' : ''}`,
									textTransform: 'capitalize'
								}}
								label={
									<div className='d-flex items-center gap-5'>
										{product?.p_type === 'beauty' &&
											o === _.get(selectedAttributes, toLower(item.vt_title)) && <IoMdCheckmark size={24} />}
										{o}
									</div>
								}
							/>
						</span>
					))}
				</div>
			</>
		);
	} else {
		return (
			<div className='d-flex flex-wrap gap-10'>
				{item?.vt_config?.map((o: any, i: any) => (
					<span key={i}>
						<Button
							extraText={discountPercentage}
							onClick={() => onVariantClick(toLower(item.vt_title), o)}
							type={o === _.get(selectedAttributes, toLower(item.vt_title)) ? 'veriant-active' : 'veriant'}
							style={{
								height: 42,
								border: `${o === selectedAttributes[toLower(item.vt_title)] ? '1px solid #e2e8f0 !important' : ''}`,
								textTransform: 'capitalize'
							}}
							label={
								<div className='d-flex items-center gap-5'>
									{product?.p_type === 'beauty' && o === _.get(selectedAttributes, toLower(item.vt_title)) && (
										<IoMdCheckmark size={24} />
									)}
									{o}
								</div>
							}
						/>
					</span>
				))}
			</div>
		);
	}
};

export default Attributes;
